import { AtSignIcon, LockIcon } from "@chakra-ui/icons";
import { Alert, AlertDescription, AlertIcon, AlertTitle, Button, Center, ChakraProvider, Checkbox, color, Heading, Image, Input, Stack, Text, theme } from "@chakra-ui/react";
import axios from "axios";
import { Form, Formik } from "formik";
import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { object, string } from "yup";
import { InputField } from "../../components/auth/InputField";
import Footer from "../../components/common/Footer";
import Header from "../../components/common/Header";
// @ts-ignore
import banner from "../../assets/images/output-onlinepngtools.png";

export default function ForgotPassword(){
    const [message, setMessage] = useState("");
    const [isSuccess, setIsSuccess] = useState(false);

    const navigate = useNavigate();

    const schema = object().shape({
        email: string().email().required("Please enter your email address")
    })

    return(
        <ChakraProvider theme={theme}>
            <Header />
            <Center bg="blue.200" style={{minHeight: '800px'}}>
                <Stack boxShadow="md" bg="whiteAlpha.900" px="20" py="10" rounded="md" my={10} >
                    <Image src={banner} alt="ju logo" maxW="100px" mx="auto" />
                    <Heading as="h1" textAlign={"center"}>Forgot Password</Heading>
                    <Text fontSize="lg" color="gray.600">
                        <Center>
                            Enter the followings <br />(We will provide you the reset link via email)
                        </Center>
                    </Text>

                    { message != "" &&
                        <>
                            {
                                isSuccess === false 
                                ?
                                    <Alert status='error'>
                                        <AlertIcon />
                                        <AlertTitle>Something went wrong!</AlertTitle>
                                        <AlertDescription>{message}</AlertDescription>
                                    </Alert>
                                :   
                                    <Alert status='success'>
                                        <AlertIcon />
                                        <AlertTitle>Succcess!</AlertTitle>
                                        <AlertDescription>{message}</AlertDescription>
                                    </Alert>
                            }
                        </>
                    }

                    <Formik
                        validationSchema={schema}
                        onSubmit={(values, { setSubmitting }) => {
                            setTimeout(() => {
                                axios({
                                    method: 'post',
                                    url: `${process.env.REACT_APP_API_URL}/api/forgot-password-send-mail`,
                                    data: values
                                })
                                .then(function ({data, status}) {
                                    if(status === 200) {
                                        setIsSuccess(true);
                                        setMessage(data.message);
                                        setTimeout(
                                            function() {
                                                navigate('/reset_password');
                                            }, 3000);
                                    }
                                })
                                .catch(function (error) {
                                    if(error.response.status == 401){
                                        setMessage(error.response.data.message);
                                    }else {
                                        setMessage('Something went wrong');
                                    }
                                });
                                setSubmitting(false);
                            }, 1000);
                        }}
                        initialValues={{ email: "" }}
                    >
                        {({ isSubmitting }) => (
                            <Form>
                                <Stack my="4" spacing="6">
                                    <InputField
                                        name="email"
                                        type="text"
                                        label="Email Address"
                                        placeholder="Enter your email"
                                        leftAddon={<AtSignIcon color="blue.500" />}
                                    />
                                    <Button
                                        isLoading={isSubmitting}
                                        loadingText="Connecting to server"
                                        size="lg"
                                        colorScheme="blue"
                                        type="submit"
                                    >
                                        Submit
                                    </Button>
                                </Stack>
                            </Form>
                        )}
                    </Formik>
                    <Stack justify="center" color="gray.600" spacing="3">
                        <Text as="div" textAlign="center">
                            <span>Remembered? </span>
                            <Button colorScheme="blue" variant="link" >
                                <Link to='/login'>Back to Login!!</Link>
                            </Button>
                        </Text>
                    </Stack>
                </Stack>
            </Center>
            <Footer />
        </ChakraProvider>
    )
}
